import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";

const BookSection = ({data}) => {
    console.log(data);
    const navigate = useNavigate();
    const deleteHandler = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this book?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`https://bookstore-backend-bk7y.onrender.com/api/v1/deleteBook/${id}`);
      alert("Book deleted successfully!");
      navigate(0); 
    } catch (error) {
      console.error("Error deleting book:", error);
      alert("Failed to delete book. Please try again.");
    }
};
  return (
    <div className='d-flex justify-content-around align-items-center flex-wrap mt-3 mb-0' style={{backgroundImage:"linear-gradient(0deg,#000 #03033f)"}}>
          {data && data.map((item,index)=> 
          <div className='m-3' style={{width:"200px",height:"350px",border:"1px solid white",borderRadius:"20px"}}> 
          <div>
            <img style={{width:"200px", height:"210px",borderTopLeftRadius:"20px",borderTopRightRadius:"20px"}} className="img-fluid" src={item.image} alt="" />
            </div>
            <h6 style={{fontSize:"15px"}} className="px-2 my-1 text-white">{item.bookname.slice(0,20)}...</h6>
            <b style={{fontSize:"30px",color:"red"}} className='mb-3 px-2'>Rs. {item.price}</b>
            <div className='d-flex justify-content-around align-items-center my-2'>
                <Link to={`/updateBook/${item._id}`} className='btn btn-primary'>UPDATE</Link>

               <button onClick ={()=>deleteHandler(item._id)} className='btn btn-danger'>DELETE</button>
               </div>
            
          </div>
          
        )}
    </div>
  )
}

export default BookSection
